
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import ToolButton from '../toolbar/ToolButton';

const ButtonCommandTool = (props) => {

    const classNames = mergeStyleSets({
        default: {
            backgroundColor: 'rgba(128, 128, 128, 0.7)',
            borderRadius: '0px'
        },
        selected: {
            backgroundColor: 'rgba(64, 64, 64, 0.7)',
            borderRadius: '0px'
        }
    });

    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.toolId);
        }
    }

    const getClassName = () => {
        return (props.selected) ? classNames.selected : classNames.default;
    }

    const getIconProps = () => {
        if (props.iconName) {
            return ToolButton.getIcon(props.iconName);
        }
        if (props.iconSrc) {
            return {
                imageProps: {
                    src: props.iconSrc
                }
            };
        }
        console.warn(`ButtonCommandTool require prop "iconName" or "iconSrc"`);
    }

    const getStyles = () => {
        if (props.iconSrc) {
            return {
                icon: {
                    height: 24,
                    width: 24
                }
            };
        }
    }

    return (
        <IconButton
            className={getClassName()}
            iconProps={getIconProps()}
            title={props.title}
            onClick={onClick}
            styles={getStyles()}
        />
    );
}

export default ButtonCommandTool;
